module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Bold.ttf
// module id = 1891
// module chunks = 0